import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface CopyStopsProps {
  color?: string;
  style?: React.CSSProperties;
}

export const CopyStopsIcon = ({ color = RoutalPalette.white, style = {}, ...props }: CopyStopsProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 15 15" style={{ width: `15px`, height: `15px`, ...style }}>
      <path d="M10.8801 2.04712L10.8801 12.9433" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13.3984 10.425L10.8801 12.9434L8.36182 10.425"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.05035 12.9434L4.05035 2.04718" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1.53205 4.56543L4.05036 2.04712L6.56866 4.56543"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
